import yup from 'schemas/yup'
import { SubjectType } from 'constants/index'
export const subjectUpdateSchema = () =>
  yup.object().shape({
    email: yup.string().email().label('Email').required(),
    type: yup.string().label('Subject Type').required('Subject type is required')
  })

export const bulkImportSubjectsSchema = () =>
  yup.object().shape({
    type: yup.string().label('Subject Type').required('Subject type is required')
  })

export const singleSubjectInviteSchema = (type) =>
  yup.object().shape({
    fullName: yup
      .string()
      .label(`${type === SubjectType.SPONSOR ? 'Company' : type + ' Name'}`)
      .required(),
    email: yup.string().email().label('Email').required()
  })

export const speakerTalkSchema = yup.object().shape({
  title: yup.string().label('Title').trimmedRequired('Talk Title is required'),
  synopsis: yup.string().label('Talk Synopsis').trimmedRequired('Talk Synopsis is required'),
  havePolls: yup.string().oneOf(['yes', 'no'])
})
